import React from 'react';

type MentoLogoProps = {
  width?: number;
  height?: number;
  variant?: 'default' | 'white';
};

export const MentoLogo: React.FC<MentoLogoProps> = ({
  width = 64,
  height = 24,
  variant = 'default',
}) => {
  const isWhite = variant === 'white';
  const iconFill = isWhite ? '#FFFFFF' : 'url(#mentoGradient)';
  const textFill = isWhite ? '#FFFFFF' : '#1F2A37';

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 128 48"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Mento"
    >
      {!isWhite && (
        <defs>
          <linearGradient id="mentoGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#FFB26B" />
            <stop offset="100%" stopColor="#FF6F91" />
          </linearGradient>
        </defs>
      )}
      <g fill="none" fillRule="evenodd">
        <path d="M8 36 L24 12 L40 36 Z" fill={iconFill} />
        <text
          x="52"
          y="34"
          fontFamily="Inter, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial"
          fontWeight="700"
          fontSize="24"
          fill={textFill}
        >
          Mento
        </text>
      </g>
    </svg>
  );
};

export default MentoLogo;
